export const updateYearStates = (
  yearStates: Record<string, boolean>,
  year: string,
): Record<string, boolean> => {
  const yearKeys = Object.keys(yearStates)
  const yearIndex = yearKeys.indexOf(year)

  if (yearIndex === -1) return yearStates

  return yearKeys.reduce(
    (acc, key, index) => {
      acc[key] = yearStates[year] ? index < yearIndex : index <= yearIndex
      return acc
    },
    {} as Record<string, boolean>,
  )
}
